import React from 'react';

export default function Slogan() {
    return (
        <div className="theme-bg-gradient position-relative">
            <div className="theme-bg-shapes-right"></div>
            <div className="theme-bg-shapes-left"></div>
            <div className="container">
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-40 animated wow fadeInUp animation-delay-5">
                        <p className="slogan text-center no-margin">"A juventude do teu corpo é breve. Utilize-a para armazenar valores eternos."<br /><span>Joanna de Ângelis</span></p>
                    </div>
                </div>
            </div>
        </div>
    );
}